import React, { useState, useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import {
    Dialog, DialogContent, DialogActions, Button,
} from '@mui/material'
import SelectionTable from 'components/datatable/SelectionTable'
import { DefaultDialogTitle } from 'components/styled/Dialog'

const DataTypeSelectionDialog = ({ open, availableItems, defaultSelected, requiredIds = [], onCancel, onValidate }) => {
    const [selectedKeys, setSelectedKeys] = useState(defaultSelected)

    useEffect(() => {
        setSelectedKeys(defaultSelected)
    }, [defaultSelected, open])

    const rows = useMemo(() => availableItems.map(item => ({ id: item.key, label: item.label })), [availableItems])

    const selectedRows = rows.filter(r => selectedKeys.includes(r.id))
    const listRows = rows.filter(r => !selectedKeys.includes(r.id))

    const customHeaders = { label: i18n.dataType }
    const isRequired = key => requiredIds.includes(key)

    return (
        <Dialog open={open} onClose={onCancel} maxWidth='md' fullWidth>
            <DefaultDialogTitle title={i18n.applyChangesOnDataTypes} onClose={onCancel} />
            <DialogContent>
                <SelectionTable
                    listTitle={i18n.available}
                    selectedTitle={i18n.selected}
                    listData={listRows}
                    selectedData={selectedRows}
                    listHeaders={['label']}
                    selectedHeaders={['label']}
                    listCustomHeaders={customHeaders}
                    selectedCustomHeaders={customHeaders}
                    onAdd={row => setSelectedKeys(prev => [...prev, row.id])}
                    onDelete={row => {
                        if (isRequired(row.id)) return
                        setSelectedKeys(prev => prev.filter(k => k !== row.id))
                    }}
                    addAll={list => setSelectedKeys(list.map(r => r.id))}
                    deleteAll={() => setSelectedKeys(requiredIds)}
                    maxHeight='300px'
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    disabled={selectedKeys.length === 0}
                    onClick={() => onValidate(selectedKeys)}
                >
                    {i18n.apply}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DataTypeSelectionDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    availableItems: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    defaultSelected: PropTypes.arrayOf(PropTypes.string).isRequired,
    requiredIds: PropTypes.arrayOf(PropTypes.string),
    onCancel: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
}

export default DataTypeSelectionDialog
